import React from 'react'
import ExampleBoxes from './ExampleBoxes/ExampleBoxes'

function ExampleSearches () {
  return (
    <section style={{ marginTop: '26px' }}>
      <div style={{ marginBottom: '29px' }}>
        <h1
          style={{
            fontSize: '14px',
            fontWeight: '500',
            color: '#000000',
            marginBottom: '10px'
          }}
        >
          Example searches
        </h1>
        <p style={{ fontSize: '12px', color: '#000000' }}>
          Select one of the options below to load in the given search
          parameters.
        </p>
      </div>
      <ExampleBoxes />
    </section>
  )
}

export default ExampleSearches
